export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    couponList: [
            {
                couponIdx : 1,
                couponName:"1000원 할인",
                couponType: 1,
                couponDiscount : 1000,
                couponMaxDiscount : 1000,
            },
            {
                couponIdx : 2,
                couponName:"10% 할인",
                couponType: 2,
                couponDiscount : 10,
                couponMaxDiscount : 20000,
            },
            {
                couponIdx : 3,
                couponName:"10000원 할인",
                couponType: 1,
                couponDiscount : 10000,
                couponMaxDiscount : 10000,
            },
            {
                couponIdx : 4,
                couponName:"90% 할인",
                couponType: 2,
                couponDiscount : 90,
                couponMaxDiscount : 100000,
            },
        ]
    }
}